import { render, staticRenderFns } from "./SoNote.vue?vue&type=template&id=281be1ca"
import script from "./SoNote.vue?vue&type=script&lang=js"
export * from "./SoNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports